import styles from './Tag.module.scss'
import cn from 'classnames'

interface ITagProps {
   children: React.ReactNode
   color?:
      | 'purple'
      | 'navy'
      | 'indigo'
      | 'gray'
      | 'warning'
      | 'success'
      | 'danger'
   noBackground?: boolean
   noBorder?: boolean
   shape?: 'round' | 'square' | 'circle'
   size?: 'small' | 'medium' | 'large'
}

export const Tag = ({
   children,
   color = 'purple',
   noBackground = false,
   noBorder = false,
   shape = 'round',
   size = 'small',
}: ITagProps) => {
   return (
      <div
         className={cn(styles.tag, styles[`color-${color}`], {
            [styles['no-background']]: noBackground,
            [styles['no-border']]: noBorder,
            [styles[`${shape}-shape`]]: shape,
            [styles[`${size}-size`]]: size,
         })}
      >
         {children}
      </div>
   )
}
